module.exports = __webpack_public_path__ + "media/reskin-images/icon--chevrons-right-2f4afb1a.svg";